// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard, agentCredentialStatusGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    algorithm: z.string().min(1).max(32),
    publicJwk: jsonObjectGuard,
    thumbprint: z.string().min(1).max(128),
    status: agentCredentialStatusGuard.optional(),
    verifiedAt: z.number().nullable().optional(),
    revokedAt: z.number().nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    agentId: z.string().min(1).max(21),
    algorithm: z.string().min(1).max(32),
    publicJwk: jsonObjectGuard,
    thumbprint: z.string().min(1).max(128),
    status: agentCredentialStatusGuard,
    verifiedAt: z.number().nullable(),
    revokedAt: z.number().nullable(),
    createdAt: z.number(),
});
export const AgentPublicKeys = Object.freeze({
    table: 'agent_public_keys',
    tableSingular: 'agent_public_key',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        agentId: 'agent_id',
        algorithm: 'algorithm',
        publicJwk: 'public_jwk',
        thumbprint: 'thumbprint',
        status: 'status',
        verifiedAt: 'verified_at',
        revokedAt: 'revoked_at',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'agentId',
        'algorithm',
        'publicJwk',
        'thumbprint',
        'status',
        'verifiedAt',
        'revokedAt',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
